<dashboard-dialog-frame icon='fa-regular fa-award' [header]="dialogContext.data?.accName + ' Class Events'" [dialogRef]='dialogRef' [actions]="dialogActions">

	<div class="p-2">
		<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="dialogContext.dimensions().bodyHeight - 20"
			[rows]="dialogDataService.classEvents()"></grid-content>
	</div>

</dashboard-dialog-frame>